export const LOADING_RECOVERY_DELAY_MS = 3000;

type LookupState = boolean | null;

export const formatLookupState = (state: LookupState) => {
  if (state === null) return "Checking";
  return state ? "Found" : "Not found";
};
